import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { PerioTooth } from '../models/perio.models';

@Component({
  standalone: false,
  selector: 'app-probing-depth-summary',
  templateUrl: './probing-depth-summary.component.html',
  styleUrls: ['./probing-depth-summary.component.css']
})
export class ProbingDepthSummaryComponent implements OnInit {

  summarySections: any[] = [
    {
      name: 'Probing Depths',
      id: 1,
      small: false,
      headers: [
        { name: '', id: 1 },
        { name: '# of Teeth', id: 2 },
        { name: '# of Sites', id: 3 }
      ],
      sections: [
        { name: '1 - 3MM', id: 1, values: [ 20, 55 ] },
        { name: '4 - 5MM', id: 2, values: [ 29, 93 ] },
        { name: '6+ MM', id: 3, values: [ 20, 44 ] },
      ],      
    },
    {
      name: 'Clinical Attachment Level',
      id: 2,
      small: false,
      headers: [
        { name: '', id: 1 },
        { name: '# of Teeth', id: 2 },
        { name: '# of Sites', id: 3 }
      ],
      sections: [
        { name: '1 - 3MM', id: 1, values: [20, 55] },
        { name: '4 - 5MM', id: 2, values: [29, 93] },
        { name: '6+ MM', id: 3, values: [20, 44] },
      ],
    },
    {
      name: 'Average Probing Depth',
      id: 3,
      small: true,
      borderRight: true,
      headers: [
        { name: 'Sextant', id: 1 },
        { name: 'Value', id: 2 },
      ],
      sections: [
        { name: 'S1', id: 1, values: [6] },
        { name: 'S2', id: 1, values: [4] },
        { name: 'S3', id: 1, values: [5] },
        { name: 'S4', id: 1, values: [5] },
        { name: 'S5', id: 1, values: [2] },
        { name: 'S6', id: 1, values: [1] },
      ],
    },
    {
      name: 'Lowest Probing Depth',
      id: 3,
      small: true,
      paddingLeft: true,
      headers: [
        { name: 'Sextant', id: 1 },
        { name: 'Value', id: 2 },
      ],
      sections: [
        { name: 'S1', id: 1, values: [6] },
        { name: 'S2', id: 1, values: [4] },
        { name: 'S3', id: 1, values: [5] },
        { name: 'S4', id: 1, values: [5] },
        { name: 'S5', id: 1, values: [2] },
        { name: 'S6', id: 1, values: [1] },
      ],
    },
  ];
  chartTeeth: PerioTooth[];
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ProbingDepthSummaryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.chartTeeth = this.data.chartTeeth;
  }

  async ngOnInit() {

    this.isLoading = true;

    let probingDepths = await this.calculateSummaryProbingDepths();
    let attachmentLevels = await this.calculateSummaryClinicalAttachmentLevel();
    let averageProbingDepth = await this.calculateSummaryAverageProbingDepth();
    let lowestProbingDepth = await this.calculateSummaryLowestProbingDepth();

    this.summarySections[0].sections = probingDepths;
    this.summarySections[1].sections = attachmentLevels;
    this.summarySections[2].sections = averageProbingDepth;
    this.summarySections[3].sections = lowestProbingDepth;

    this.isLoading = false;

  }

  close() {
    this.dialogRef.close();
  }

  calculateSummaryProbingDepths() {
    let promise = new Promise((resolve, reject) => {

      let toothKeys: string[] = [
        'FacialProbingDepthD',
        'FacialProbingDepthC',
        'FacialProbingDepthM',
        'LingualProbingDepthD',
        'LingualProbingDepthC',
        'LingualProbingDepthM'
      ];

      var tableObj: any = {
        1: { name: '1 - 3MM', id: 1, toothIsAdded: false, toothCount: 0, siteCount: 0, values: [20, 55] },
        2: { name: '4 - 5MM', id: 2, toothIsAdded: false, toothCount: 0, siteCount: 0, values: [29, 93] },
        3: { name: '6+ MM', id: 3, toothIsAdded: false, toothCount: 0, siteCount: 0, values: [20, 44] },
      };   

      this.chartTeeth.forEach(tooth => {
        if (!tooth.ToothIsMissing) {
          
          tableObj[1].toothIsAdded = false;
          tableObj[2].toothIsAdded = false;
          tableObj[3].toothIsAdded = false;

          toothKeys.forEach(key => {
            var toothValue = tooth[key];

            if (!isNaN(toothValue)) {

              if (toothValue >= 1 && toothValue <= 3) {
                tableObj[1].siteCount++;
                if (!tableObj[1].toothIsAdded) {
                  tableObj[1].toothCount++;
                  tableObj[1].toothIsAdded = true;
                }
              } else if (toothValue >= 4 && toothValue <= 5) {
                tableObj[2].siteCount++;
                if (!tableObj[2].toothIsAdded) {
                  tableObj[2].toothCount++;
                  tableObj[2].toothIsAdded = true;
                }
              } else if (toothValue >= 6) {
                tableObj[3].siteCount++;
                if (!tableObj[3].toothIsAdded) {
                  tableObj[3].toothCount++;
                  tableObj[3].toothIsAdded = true;
                }
              }
            }

          });
        }
      });

      var finalObjs: any[] = [
        { name: '1 - 3MM', id: 1, values: [ tableObj[1].toothCount, tableObj[1].siteCount ] },
        { name: '4 - 5MM', id: 2, values: [tableObj[2].toothCount, tableObj[2].siteCount] },
        { name: '6+ MM', id: 3, values: [tableObj[3].toothCount, tableObj[3].siteCount] },
      ]

      resolve(finalObjs);

    });
    return promise;
  }

  calculateSummaryClinicalAttachmentLevel() {
    let promise = new Promise((resolve, reject) => {

      let toothKeys: string[] = [
        'FacialClinicalAttachmentLevelC',
        'FacialClinicalAttachmentLevelD',
        'FacialClinicalAttachmentLevelM',
        'LingualClinicalAttachmentLevelC',
        'LingualClinicalAttachmentLevelD',
        'LingualClinicalAttachmentLevelM'
      ];

      var tableObj: any = {
        1: { name: '1 - 3MM', id: 1, toothIsAdded: false, toothCount: 0, siteCount: 0, values: [20, 55] },
        2: { name: '4 - 5MM', id: 2, toothIsAdded: false, toothCount: 0, siteCount: 0, values: [29, 93] },
        3: { name: '6+ MM', id: 3, toothIsAdded: false, toothCount: 0, siteCount: 0, values: [20, 44] },
      };

      this.chartTeeth.forEach(tooth => {
        if (!tooth.ToothIsMissing) {

          tableObj[1].toothIsAdded = false;
          tableObj[2].toothIsAdded = false;
          tableObj[3].toothIsAdded = false;

          toothKeys.forEach(key => {
            var toothValue = tooth[key];

            if (!isNaN(toothValue)) {

              if (toothValue >= 1 && toothValue <= 3) {
                tableObj[1].siteCount++;
                if (!tableObj[1].toothIsAdded) {
                  tableObj[1].toothCount++;
                  tableObj[1].toothIsAdded = true;
                }
              } else if (toothValue >= 4 && toothValue <= 5) {
                tableObj[2].siteCount++;
                if (!tableObj[2].toothIsAdded) {
                  tableObj[2].toothCount++;
                  tableObj[2].toothIsAdded = true;
                }
              } else if (toothValue >= 6) {
                tableObj[3].siteCount++;
                if (!tableObj[3].toothIsAdded) {
                  tableObj[3].toothCount++;
                  tableObj[3].toothIsAdded = true;
                }
              }
            }

          });
        }
      });

      var finalObjs: any[] = [
        { name: '1 - 3MM', id: 1, values: [tableObj[1].toothCount, tableObj[1].siteCount] },
        { name: '4 - 5MM', id: 2, values: [tableObj[2].toothCount, tableObj[2].siteCount] },
        { name: '6+ MM', id: 3, values: [tableObj[3].toothCount, tableObj[3].siteCount] },
      ]

      resolve(finalObjs);

    });
    return promise;
  }

  calculateSummaryAverageProbingDepth() {
    let promise = new Promise((resolve, reject) => {

      let probingDepthKeys: string[] = [
        'FacialProbingDepthD',
        'FacialProbingDepthC',
        'FacialProbingDepthM',
        'LingualProbingDepthD',
        'LingualProbingDepthC',
        'LingualProbingDepthM'
      ];

      let sections: any[] = [
        { name: 'S1', id: 1, values: [6] },
        { name: 'S2', id: 1, values: [4] },
        { name: 'S3', id: 1, values: [5] },
        { name: 'S4', id: 1, values: [5] },
        { name: 'S5', id: 1, values: [2] },
        { name: 'S6', id: 1, values: [1] },
      ];

      let sextantObjs: any[] = [
        { sextant: 1, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 2-5
        { sextant: 2, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 6-11
        { sextant: 3, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 12-15
        { sextant: 4, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 18-21
        { sextant: 5, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 22-27
        { sextant: 6, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 28-31
      ];

      sextantObjs.forEach((sextantObj, i) => {

        let startTooth: number = 0;
        let endTooth: number = 0;

        let averageDepthAccumulator: number = 0;
        let averageDepthCount: number = 0;
        let lowestDepth: number = 100;

        switch (sextantObj.sextant) {
          case 1:
            startTooth = 2;
            endTooth = 5;
            break;
          case 2:
            startTooth = 6;
            endTooth = 11;
            break;
          case 3:
            startTooth = 12;
            endTooth = 15;
            break;
          case 4:
            startTooth = 18;
            endTooth = 21;
            break;
          case 5:
            startTooth = 22;
            endTooth = 27;
            break;
          case 6:
            startTooth = 28;
            endTooth = 31;
            break;
        }

        for (let i = startTooth; i <= endTooth; i++) {
          let index = i - 1;
          let tooth: PerioTooth = this.chartTeeth[index];

          if (!tooth.ToothIsMissing) {
            probingDepthKeys.forEach(key => {

              let toothValue: number = 0;
              let skipFlag: boolean = false;
              if (!isNaN(tooth[key])) {
                toothValue = tooth[key];
              } else {
                skipFlag = true;
              }

              if (!skipFlag) {
                averageDepthAccumulator += toothValue;
                averageDepthCount++;

                if (toothValue < lowestDepth) {
                  lowestDepth = toothValue;
                }
              }

            });
          }
        }

        if (averageDepthCount === 0) {
          averageDepthCount = 1;
        }

        var averageDepth: number = averageDepthAccumulator / averageDepthCount;
        let sextantAverageDepth = Math.round(averageDepth * 10) / 10;

        sections[i].values = [sextantAverageDepth];
      });

      resolve(sections);

    });
    return promise;
  }

  calculateSummaryLowestProbingDepth() {
    let promise = new Promise((resolve, reject) => {

      let probingDepthKeys: string[] = [
        'FacialProbingDepthD',
        'FacialProbingDepthC',
        'FacialProbingDepthM',
        'LingualProbingDepthD',
        'LingualProbingDepthC',
        'LingualProbingDepthM'
      ];

      let sections: any[] = [
        { name: 'S1', id: 1, values: [6] },
        { name: 'S2', id: 1, values: [4] },
        { name: 'S3', id: 1, values: [5] },
        { name: 'S4', id: 1, values: [5] },
        { name: 'S5', id: 1, values: [2] },
        { name: 'S6', id: 1, values: [1] },
      ];

      let sextantObjs: any[] = [
        { sextant: 1, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 2-5
        { sextant: 2, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 6-11
        { sextant: 3, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 12-15
        { sextant: 4, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 18-21
        { sextant: 5, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 22-27
        { sextant: 6, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 28-31
      ];

      sextantObjs.forEach((sextantObj, i) => {

        let startTooth: number = 0;
        let endTooth: number = 0;

        let averageDepthAccumulator: number = 0;
        let averageDepthCount: number = 0;
        let lowestDepth: number = 100;

        switch (sextantObj.sextant) {
          case 1:
            startTooth = 2;
            endTooth = 5;
            break;
          case 2:
            startTooth = 6;
            endTooth = 11;
            break;
          case 3:
            startTooth = 12;
            endTooth = 15;
            break;
          case 4:
            startTooth = 18;
            endTooth = 21;
            break;
          case 5:
            startTooth = 22;
            endTooth = 27;
            break;
          case 6:
            startTooth = 28;
            endTooth = 31;
            break;
        }

        for (let i = startTooth; i <= endTooth; i++) {
          let index = i - 1;
          let tooth: PerioTooth = this.chartTeeth[index];

          if (!tooth.ToothIsMissing) {
            probingDepthKeys.forEach(key => {

              let toothValue: number = 0;
              let skipFlag: boolean = false;
              if (!isNaN(tooth[key])) {
                toothValue = tooth[key];
              } else {
                skipFlag = true;
              }

              if (!skipFlag) {
                averageDepthAccumulator += toothValue;
                averageDepthCount++;

                if (toothValue < lowestDepth) {
                  lowestDepth = toothValue;
                }
              }

            });
          }
        }

        if (averageDepthCount === 0) {
          averageDepthCount = 1;
        }

        let sextantLowestDepth = lowestDepth;     
        sections[i].values = [sextantLowestDepth];

      });

      resolve(sections);

    });
    return promise;
  }

}
